import type { Company } from '@calculom/report-designer';

export const MOCK_COMPANIES: Company[] = [
  { id: '1', name: 'Acme Corporation', erpConnectionId: 'conn-1', erpConnectionName: 'Odoo Production' },
  { id: '2', name: 'TechStart Inc', erpConnectionId: 'conn-2', erpConnectionName: 'Acumatica Cloud' },
  { id: '3', name: 'Global Enterprises', erpConnectionId: 'conn-1', erpConnectionName: 'Odoo Production' },
];
